var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6245 2H14.6245V0.5C14.6245 0.223877 14.4006 0 14.1245 0C13.8484 0 13.6245 0.223877 13.6245 0.5V2H6.62451V0.5C6.62451 0.223877 6.40063 0 6.12451 0C5.84839 0 5.62451 0.223877 5.62451 0.5V2H2.62402C1.2439 2.00146 0.125488 3.11987 0.124023 4.5V17.5C0.125488 18.8801 1.2439 19.9985 2.62402 20H17.6245C19.0047 19.9987 20.1232 18.8802 20.1245 17.5V4.5C20.1232 3.11981 19.0047 2.00128 17.6245 2ZM19.1245 17.5C19.1236 18.3281 18.4526 18.9991 17.6245 19H2.62402C1.79596 18.9991 1.12494 18.3281 1.12402 17.5V9H19.1245V17.5ZM19.1245 8H1.12402V4.5C1.12494 3.67194 1.79596 3.00092 2.62402 3H5.62451V4.5C5.62451 4.49976 5.62451 4.50018 5.62451 4.5C5.62469 4.77594 5.84851 5.00018 6.12451 5C6.12427 5 6.12469 5 6.12451 5C6.40045 4.99982 6.62469 4.776 6.62451 4.5V3H13.6245V4.5C13.6245 4.49976 13.6245 4.50018 13.6245 4.5C13.6247 4.77594 13.8485 5.00018 14.1245 5C14.1243 5 14.1247 5 14.1245 5C14.4005 4.99982 14.6247 4.776 14.6245 4.5V3H17.6245C18.4526 3.00092 19.1236 3.67194 19.1245 4.5V8Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.5a114ac8bdd639185906560cb7704e8b.svg";
export { ForwardRef as ReactComponent };